import styled from "styled-components";

import Text from "@/components/Text";

const Card = styled.div`
  background: linear-gradient(
    106.25deg,
    rgba(65, 54, 207, 0.9) 0%,
    rgba(93, 84, 214, 0.8) 100%
  );
  min-height: 251px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const Bubble1 = styled.div`
  width: 133px;
  height: 133px;
  position: absolute;
  background: linear-gradient(
    140.84deg,
    rgba(255, 255, 255, 0.1) 13.86%,
    rgba(255, 255, 255, 0) 83.54%
  );
  left: 6px;
  top: 8px;
  border-radius: 50%;
`;

const Bubble2 = styled.div`
  width: 203px;
  height: 203px;
  position: absolute;
  background: linear-gradient(
    34.64deg,
    rgba(255, 255, 255, 0.2) 16.49%,
    rgba(255, 255, 255, 0) 98.7%
  );
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border-radius: 50%;
`;

const Bubble3 = styled.div`
  width: 99px;
  height: 99px;
  position: absolute;
  background: linear-gradient(
    140.84deg,
    rgba(255, 255, 255, 0.1) 13.86%,
    rgba(255, 255, 255, 0) 83.54%
  );
  right: 22px;
  bottom: 11px;
  border-radius: 50%;
`;

const Heading = styled(Text)`
  display: flex;
  align-items: center;
  svg {
    margin-left: 16px;
    flex-shrink: 0;
    transform: translateY(2px);
  }
`;

const HomeMoreUpcoming = () => {
  return (
    <Card>
      <Bubble1 />
      <Bubble2 />
      <Bubble3 />
      <Heading $type="heading1" $color="white">
        More upcoming soon ...
        <svg
          width="33"
          height="33"
          viewBox="0 0 33 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.0759 27.2811C13.8835 27.7265 10.6166 26.5385 8.38906 24.2369L4.67676 27.7265C7.57236 30.7707 11.5814 32.4782 15.7396 32.4782C16.4077 32.4782 17.0757 32.4042 17.7443 32.3296C24.8722 31.3642 30.366 25.499 30.886 18.3713L25.7629 18C25.4656 22.7523 21.7534 26.6132 17.0757 27.2813L17.0759 27.2811Z"
            fill="currentColor"
          />
          <path
            d="M9.05802 5.73995C9.05802 8.24085 7.02991 10.269 4.52901 10.269C2.02758 10.269 0 8.24085 0 5.73995C0 3.23852 2.02758 1.21094 4.52901 1.21094C7.02991 1.21094 9.05802 3.23852 9.05802 5.73995Z"
            fill="currentColor"
          />
          <path
            d="M29.9094 0L21 5.79119L29.9094 11.5824L32.1369 8.1668L28.3501 5.79119L32.1369 3.34107L29.9094 0Z"
            fill="currentColor"
          />
        </svg>
      </Heading>
    </Card>
  );
};

export default HomeMoreUpcoming;
